import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Modal, Tabs } from 'antd'
import WrappedUpdateDevice from '../UpdateDevice'


const UpdateDeviceForm = (props) => {
  const { visible, onOk, onCancel, heroId , device } = props

  return (
    <Modal
      destroyOnClose={true}
      title="Update Device"
      visible={visible}
      onCancel={onCancel}
      footer={null}>
      <Tabs type="card" defaultActiveKey="1">
        <Tabs.TabPane tab="Update Device Available" key="1">
          <WrappedUpdateDevice
            onOk={onOk}
            onCancel={onCancel}
            heroId={heroId}
            device={device}
          />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  )
}

export default UpdateDeviceForm
